(function () {
  var galleryImages = [];
  var currentIndex = 0;

  var scale = 1;
  var startScale = 1;
  var translateX = 0;
  var translateY = 0;
  var lastX = 0;
  var lastY = 0;
  var startX = 0;
  var startY = 0;
  var initialDistance = 0;
  var isDragging = false;
  var lastTap = 0;

  var touchImg = null;
  var touchStartX = 0;
  var touchStartY = 0;
  var touchStartTime = 0;
  var touchMoved = false;

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function injectCss() {
    if (document.querySelector('#sf-mobile-zoom-css')) return;

    var style = document.createElement('style');
    style.id = 'sf-mobile-zoom-css';

    style.innerHTML = `
      @media screen and (max-width: 767px) {
        .sf-mobile-zoom-overlay {
          position: fixed;
          inset: 0;
          background: rgba(255,255,255,0.98);
          z-index: 999999999;
          display: none;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .sf-mobile-zoom-overlay.is-active {
          display: flex !important;
        }

        .sf-mobile-zoom-inner {
          width: 100vw;
          height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          touch-action: none;
        }

        .sf-mobile-zoom-img {
          max-width: 100%;
          max-height: 88vh;
          object-fit: contain;
          transform: translate3d(0,0,0) scale(1);
          transition: transform 0.04s linear;
          will-change: transform;
          user-select: none;
          -webkit-user-select: none;
          -webkit-touch-callout: none;
        }

        .sf-mobile-zoom-close {
          position: fixed;
          top: 14px;
          right: 18px;
          width: 44px;
          height: 44px;
          border: none;
          border-radius: 50%;
          background: #000;
          color: #fff;
          font-size: 30px;
          line-height: 40px;
          z-index: 1000000000;
        }

        .sf-mobile-zoom-arrow {
          position: fixed;
          top: 50%;
          transform: translateY(-50%);
          width: 42px;
          height: 56px;
          border: none;
          border-radius: 6px;
          background: rgba(0,0,0,.55);
          color: #fff;
          font-size: 44px;
          line-height: 44px;
          z-index: 1000000000;
          padding: 0;
        }

        .sf-mobile-zoom-prev {
          left: 10px;
        }

        .sf-mobile-zoom-next {
          right: 10px;
        }

        .sf-mobile-zoom-counter {
          position: fixed;
          bottom: 18px;
          left: 50%;
          transform: translateX(-50%);
          background: rgba(0,0,0,.6);
          color: #fff;
          padding: 6px 12px;
          border-radius: 999px;
          font-size: 13px;
          z-index: 1000000000;
        }

        body.sf-mobile-zoom-open {
          overflow: hidden !important;
          touch-action: none;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function getSrc(img) {
    if (!img) return '';

    var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset');

    if (srcset) {
      var parts = srcset.split(',');
      var last = parts[parts.length - 1].trim().split(' ')[0];
      if (last) return last;
    }

    return (
      img.getAttribute('data-zoom') ||
      img.getAttribute('data-original') ||
      img.getAttribute('data-src') ||
      img.getAttribute('src') ||
      ''
    );
  }

  function collectGalleryImages() {
    var imgs = document.querySelectorAll('.product-media_main .slider-item img');
    var seen = {};

    galleryImages = [];

    imgs.forEach(function (img) {
      if (!img) return;
      if (img.closest('.product-media_thumbnails')) return;

      var src = getSrc(img);

      if (!src) return;
      if (seen[src]) return;

      seen[src] = true;

      galleryImages.push({
        src: src,
        alt: img.getAttribute('alt') || ''
      });
    });
  }

  function createOverlay() {
    injectCss();

    if (document.querySelector('.sf-mobile-zoom-overlay')) return;

    var overlay = document.createElement('div');
    overlay.className = 'sf-mobile-zoom-overlay';

    overlay.innerHTML =
      '<button class="sf-mobile-zoom-close" type="button" aria-label="Chiudi zoom">×</button>' +
      '<button class="sf-mobile-zoom-arrow sf-mobile-zoom-prev" type="button" aria-label="Immagine precedente">‹</button>' +
      '<div class="sf-mobile-zoom-inner">' +
        '<img class="sf-mobile-zoom-img" src="" alt="">' +
      '</div>' +
      '<button class="sf-mobile-zoom-arrow sf-mobile-zoom-next" type="button" aria-label="Immagine successiva">›</button>' +
      '<div class="sf-mobile-zoom-counter"></div>';

    document.body.appendChild(overlay);

    overlay.querySelector('.sf-mobile-zoom-close').addEventListener('click', closeZoom);

    overlay.querySelector('.sf-mobile-zoom-prev').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      showPrev();
    });

    overlay.querySelector('.sf-mobile-zoom-next').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      showNext();
    });

    initPinchZoom();
  }

  function updateTransform() {
    var img = document.querySelector('.sf-mobile-zoom-img');
    if (!img) return;

    img.style.transform =
      'translate3d(' + translateX + 'px,' + translateY + 'px,0) scale(' + scale + ')';
  }

  function resetZoom() {
    scale = 1;
    startScale = 1;
    translateX = 0;
    translateY = 0;
    lastX = 0;
    lastY = 0;
    startX = 0;
    startY = 0;
    initialDistance = 0;
    isDragging = false;
    updateTransform();
  }

  function updateCounter() {
    var counter = document.querySelector('.sf-mobile-zoom-counter');

    if (!counter) return;

    counter.innerHTML =
      galleryImages.length > 1 ? currentIndex + 1 + ' / ' + galleryImages.length : '';
  }

  function renderImage() {
    var overlayImg = document.querySelector('.sf-mobile-zoom-img');

    if (!overlayImg || !galleryImages[currentIndex]) return;

    resetZoom();

    overlayImg.src = galleryImages[currentIndex].src;
    overlayImg.alt = galleryImages[currentIndex].alt || '';

    updateCounter();
  }

  function showNext() {
    if (galleryImages.length <= 1) return;

    currentIndex++;

    if (currentIndex >= galleryImages.length) {
      currentIndex = 0;
    }

    renderImage();
  }

  function showPrev() {
    if (galleryImages.length <= 1) return;

    currentIndex--;

    if (currentIndex < 0) {
      currentIndex = galleryImages.length - 1;
    }

    renderImage();
  }

  function openZoom(img) {
    createOverlay();
    collectGalleryImages();

    if (!galleryImages.length) return;

    var src = getSrc(img);
    currentIndex = 0;

    galleryImages.forEach(function (item, index) {
      if (item.src === src) {
        currentIndex = index;
      }
    });

    renderImage();

    document.querySelector('.sf-mobile-zoom-overlay').classList.add('is-active');
    document.body.classList.add('sf-mobile-zoom-open');
  }

  function closeZoom() {
    var overlay = document.querySelector('.sf-mobile-zoom-overlay');

    if (!overlay) return;

    overlay.classList.remove('is-active');
    document.body.classList.remove('sf-mobile-zoom-open');

    resetZoom();
  }

  function getDistance(touches) {
    var dx = touches[0].clientX - touches[1].clientX;
    var dy = touches[0].clientY - touches[1].clientY;

    return Math.sqrt(dx * dx + dy * dy);
  }

  function initPinchZoom() {
  var inner = document.querySelector('.sf-mobile-zoom-inner');

  if (!inner || inner.classList.contains('pinch-ready')) return;

  inner.classList.add('pinch-ready');

  inner.addEventListener(
    'touchstart',
    function (e) {
      if (!document.body.classList.contains('sf-mobile-zoom-open')) return;

      if (e.touches.length === 2) {
        initialDistance = getDistance(e.touches);
        startScale = scale;
        return;
      }

      if (e.touches.length === 1) {
        var now = Date.now();
        var tapLength = now - lastTap;

        if (tapLength < 300 && tapLength > 0) {
          e.preventDefault();

          if (scale <= 1.05) {
            scale = 2;
          } else {
            scale = 1;
            translateX = 0;
            translateY = 0;
            lastX = 0;
            lastY = 0;
          }

          updateTransform();
        }

        lastTap = now;

        if (scale > 1) {
          isDragging = true;
          startX = e.touches[0].clientX - lastX;
          startY = e.touches[0].clientY - lastY;
        }
      }
    },
    { passive: false }
  );

  inner.addEventListener(
    'touchmove',
    function (e) {
      if (!document.body.classList.contains('sf-mobile-zoom-open')) return;

      if (e.touches.length === 2) {
        e.preventDefault();

        var currentDistance = getDistance(e.touches);
        var newScale = startScale * (currentDistance / initialDistance);

        scale = Math.min(Math.max(newScale, 1), 4);

        if (scale <= 1.05) {
          scale = 1;
          translateX = 0;
          translateY = 0;
          lastX = 0;
          lastY = 0;
        }

        updateTransform();
        return;
      }

      if (e.touches.length === 1 && isDragging && scale > 1) {
        e.preventDefault();

        translateX = e.touches[0].clientX - startX;
        translateY = e.touches[0].clientY - startY;

        updateTransform();
      }
    },
    { passive: false }
  );

  inner.addEventListener('touchend', function () {
    lastX = translateX;
    lastY = translateY;
    isDragging = false;

    if (scale <= 1.05) {
      scale = 1;
      translateX = 0;
      translateY = 0;
      lastX = 0;
      lastY = 0;
      updateTransform();
    }
  });
}

  function getProductImage(target) {
    if (!target) return null;

    var img = target.closest('.product-media_main .slider-item img');

    if (!img) return null;
    if (img.closest('.product-media_thumbnails')) return null;

    return img;
  }

  document.addEventListener(
    'touchstart',
    function (e) {
      if (!isMobile()) return;
      if (document.body.classList.contains('sf-mobile-zoom-open')) return;
      if (!e.touches || e.touches.length !== 1) return;

      var img = getProductImage(e.target);

      if (!img) {
        touchImg = null;
        return;
      }

      touchImg = img;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchStartTime = Date.now();
      touchMoved = false;
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) {
      if (!isMobile()) return;
      if (!touchImg) return;
      if (document.body.classList.contains('sf-mobile-zoom-open')) return;
      if (!e.touches || e.touches.length !== 1) return;

      var diffX = Math.abs(e.touches[0].clientX - touchStartX);
      var diffY = Math.abs(e.touches[0].clientY - touchStartY);

      if (diffX > 6 || diffY > 6) {
        touchMoved = true;
      }
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      if (!isMobile()) return;
      if (document.body.classList.contains('sf-mobile-zoom-open')) return;
      if (!touchImg) return;

      var duration = Date.now() - touchStartTime;
      var img = touchImg;

      touchImg = null;

      if (touchMoved) return;
      if (duration > 450) return;

      e.preventDefault();
      e.stopPropagation();

      openZoom(img);
    },
    { passive: false, capture: true }
  );

  document.addEventListener(
    'touchcancel',
    function () {
      touchImg = null;
      touchMoved = false;
    },
    { passive: true, capture: true }
  );

  document.addEventListener('DOMContentLoaded', function () {
    createOverlay();
  });

  window.addEventListener('load', function () {
    createOverlay();
  });
})();